module.exports = __webpack_public_path__ + "static/media/nuvemshop3.1da000d8.png";